import { gsap } from "./gsapSetup";

export default function initMouseStars({
                                         selector = ".mouse-stars-layer",
                                         count = 30,
                                         // strength = 20,
                                         // maxOffset = 8
                                       } = {}) {
  const container = document.querySelector(selector)
  if (!container) return

  // respect accessibility
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return
  if (window.matchMedia("(pointer: coarse)").matches) return

  // create stars
  const fragment = document.createDocumentFragment()

  for (let i = 0; i < count; i++) {
    const star = document.createElement("div")
    star.className = "star"
    star.style.left = Math.random() * 100 + "%"
    star.style.top = Math.random() * 100 + "%"
    fragment.appendChild(star)
  }

  container.appendChild(fragment)

  const stars = gsap.utils.toArray(".star");
  window.addEventListener("mousemove", e => {
    const x = (e.clientX / window.innerWidth - 0.5) * 20
    const y = (e.clientY / window.innerHeight - 0.5) * 20

    stars.forEach((star, i) => {
      gsap.to(star, {
        x: x * (i + 1) * 0.4,
        y: y * (i + 1) * 0.4,
        duration: 0.8,
        ease: "power3.out"
      })
    })
  })
}
